import { DomainDetail, DomainOwner } from "@dev/ee-api/ee-api-models";

export const isOwnDomain = (domain: DomainDetail): boolean => domain.Ownership === DomainOwner.Current;
